export const workdayType = ['Tiempo completo', 'Tiempo parcial'];
export const startMonth = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const startYear = (): string[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 10 }, (_, index) => (currentYear - index).toString());
};
